import {GetSeferData}   from "SeferPetach/GetData";

export async function getOrdersList(obj) {
    var payload = await GetSeferData("of17", obj);
    return (payload);
}
export async function getParamOrdersList(obj) {
    var payload = await GetSeferData("of17", obj);
    return (payload);
}
export async function getOrderByID(order_id){
    var payload = await GetSeferData("of3", {'ORDER_ID': order_id});
    return (payload);
}
export async function getOrderMeta() {
    var payload = await GetSeferData("auxf3", {});
    return (payload);
}
export async function updateOrder(obj){
    var args = obj;
    var payload = await GetSeferData("of4", args);
    return (payload);
}
export async function updateOrderNotification(obj){
    var args = obj;
    var payload = await GetSeferData("of14", args);
    return (payload);
}
export async function updateOrderStatus(order_id, status_id){
    var payload = await GetSeferData("of12", {ORDER_ID: order_id, STATUS_ID: status_id});
    return (payload);
}
export async function deleteOrder(order_id){
    var payload = await GetSeferData("of5", {'ORDER_ID': order_id});
    return (payload);
}
export async function copyOrder(order_id){
    var payload = await GetSeferData("of15", {'ORDER_ID': order_id});
    return (payload);
}
export async function regenFiles(order_id){
    var payload = await GetSeferData("of16", {'ORDER_ID': order_id});
    return (payload);
}
export async function getOrderSearchData() {
    var payload = await GetSeferData("of18", {});
    return (payload);
}
export async function closeOrderByID(order_id){
    var payload = await GetSeferData("of20", {'ORDER_ID': order_id});
    return (payload);
}